export async function updateGiftCardCodes(endpoint, storefrontAccessToken, cartId, giftCardCode) {
    const query = `
      mutation cartGiftCardCodesUpdate($cartId: ID!, $giftCardCodes: [String!]!) {
        cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $giftCardCodes) {
          cart {
            id
            appliedGiftCards {
              amountUsed {
                amount
                currencyCode
              }
              balance {
                amount
                currencyCode
              }
            }
            cost {
              subtotalAmount {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              checkoutChargeAmount{
                amount
                currencyCode
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken
      },
      body: JSON.stringify({
        query,
        variables: {
          cartId,
          giftCardCodes: giftCardCode
        }
      })
    });

    return await response.json();
}